module.exports = "<report-page></report-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/report.html
// module id = 1621
// module chunks = 0